import { Pipe, PipeTransform } from '@angular/core';

/**
 * A custom Angular Pipe that capitalizes the first letter of each word in a given string.
 *
 * This pipe ensures proper capitalization, handling words separated by spaces,
 * dashes, or other typical delimiters. It uses Unicode-aware regular expressions
 * to properly handle various locales and character sets.
 *
 * @example
 * <!-- In your Angular template -->
 * {{ 'john doe' | capitalizeName }} <!-- Outputs: 'John Doe' -->
 *
 * @example
 * import { CapitalizeNamePipe } from './capitalize-name.pipe';
 *
 * const pipe = new CapitalizeNamePipe();
 * console.log(pipe.transform('mary-jane')); // Outputs: 'Mary-Jane'
 */
@Pipe({
  name: 'capitalizeName',
  standalone: true,
})
export class CapitalizeNamePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    return value.toLowerCase().replace(/(?:^|[\s-])\p{L}/gu, (match) => match.toUpperCase());
  }
}
